var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriptionEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 997,
    height: 781,
    viewBox: "0 0 997 781",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1163_9388)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 690,
    cy: 109.5,
    rx: 140,
    ry: 121.5,
    fill: "#2F5C27"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1163_9388",
    x: 0,
    y: -562,
    width: 1380,
    height: 1343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 275,
    result: "effect1_foregroundBlur_1163_9388"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionEllipse);
export default __webpack_public_path__ + "static/media/subscription-ellipse.402680910af1fd259f48095e94cd79ff.svg";
export { ForwardRef as ReactComponent };